import type { Types } from '@fiverr-private/theme';

export const DEFAULT_PADDING_X: Types.ContainerProps['paddingX'] = { default: '6', sm: '8' };
export const DEFAULT_PADDING_TOP: Types.ContainerProps['paddingTop'] = { default: '4', sm: '6' };
export const DEFAULT_PADDING_BOTTOM: Types.ContainerProps['paddingBottom'] = '4';
